import { useEffect } from 'react';
import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { useSelector } from 'react-redux';
import { Button } from '@simplywallst/ui-core';
import PageAnchor from '@components/PageAnchor';
import { COMPANY_ABOUT_ANCHOR } from '@/constants/anchors';
import { getViewMode } from '@/redux/location/selectors';
import { ViewMode } from '@/pages/CompanyReport/enum';
import { useDwellTracking } from '@/pages/CompanyReport/components/DwellTrackingProvider';
import { useReportSection } from '@/pages/CompanyReport/components/ReportSectionProvider';
import AboutTheCompanyContent from '../AboutTheCompanyContent';
import { useTranslation } from '@/hooks/useTranslation';

type Props = {
  showAboutCompany: boolean;
  handleShowAboutCompany: (value: boolean) => void;
};
function AboutTheCompanySection({
  showAboutCompany,
  handleShowAboutCompany,
}: Props) {
  const { observe } = useDwellTracking();
  const { section } = useReportSection();
  const viewMode = useSelector(getViewMode);

  useEffect(() => {
    if (viewMode === ViewMode.Print) handleShowAboutCompany(true);
  }, [viewMode, handleShowAboutCompany]);

  const t = useTranslation();

  return (
    <>
      <PageAnchor id={COMPANY_ABOUT_ANCHOR} />
      <Section
        data-cy-id="about-the-company"
        data-section={section}
        ref={observe}
      >
        <AboutTheCompanyContent expanded={showAboutCompany} />
        <Button
          displayXsDown="block"
          onClick={() => handleShowAboutCompany(!showAboutCompany)}
          styleType="loud"
          data-cy-id="company-description-toggle"
        >
          {showAboutCompany
            ? t('page.companyReport.overview.about.showLess')
            : t('page.companyReport.overview.about.showMore')}
        </Button>
      </Section>
    </>
  );
}
export default AboutTheCompanySection;
